<template>

    <div :class=" tabClasses ">

        <p @click=" appInstall() ">install app</p>
        <p class="install-dismiss" @click=" dismissInstall() ">dismiss</p>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'install-bar',
        computed: {

            ...mapGetters({

                tabOpen : 'orderTab/tabOpen'
            }),
            tabClasses: function(){

                let base = [ 'install-bar-wrapper' ];
                base.push( this.tabOpen ? 'tab-opened' : '' );

                return base.join( ' ' );
            }
        },
        methods: {

            dismissInstall(){

                this.$store.dispatch( 'pwa/toggleInstallable' );
            },
            appInstall(){

                console.log( 'trigger install' );
            }
        }
    }
</script>

<style scoped>

    .install-bar-wrapper {

        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;

        font-weight: bold;
        padding: 0px 5px;
        box-sizing: border-box;
        transition: all 0.3s ease-in;
        bottom: -1px;
        width: 100%;
        background-color: white;
        z-index: 499;
        height: 55px;
    }
    .tab-opened {

        bottom: 55px;
    }
    .install-dismiss {

        position: absolute;
        font-weight: 300;
        right: 5px;
        color: #555;
    }
    p {

        margin: 0;
    }
</style>